import React from 'react';
import { Modal, Typography, Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';

const CustomTrainingWorkoutsInfoModal = ({ isOpen, onClose, workouts }) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          maxWidth: '80vw',
          maxHeight: '70vh',
          overflowY: 'auto',
          margin: 'auto',
          marginTop: '100px',
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: 24,
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Custom Training Workouts
        </Typography>
        <Grid container spacing={2}>
          {workouts && workouts.length > 0 ? (
            workouts.map((workout, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Box sx={{ padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '5px' }}>
                  <Typography><strong>Name:</strong> {workout.name}</Typography>
                  <Typography><strong>Description:</strong> {workout.description}</Typography>
                  <Typography><strong>Calories:</strong> {workout.calories}</Typography>
                  <Typography><strong>Distance (km):</strong> {workout.distanceKm.toFixed(2)}</Typography>
                  <Typography><strong>Repetitions:</strong> {workout.repetitions}</Typography>
                  <Typography><strong>Sets:</strong> {workout.sets}</Typography>
                  <Typography><strong>Time (minutes):</strong> {workout.timeMinutes}</Typography>
                  <Typography><strong>Workout Order:</strong> {workout.workoutOrder}</Typography>
                </Box>
              </Grid>
            ))
          ) : (
            <Typography>No workouts available for this training.</Typography>
          )}
        </Grid>
      </Box>
    </Modal>
  );
};

CustomTrainingWorkoutsInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  workouts: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      calories: PropTypes.number.isRequired,
      distanceKm: PropTypes.number.isRequired,
      repetitions: PropTypes.number.isRequired,
      sets: PropTypes.number.isRequired,
      timeMinutes: PropTypes.number.isRequired,
      workoutOrder: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default CustomTrainingWorkoutsInfoModal;
